import styled from '@emotion/styled';

export const MobileFiltersToggle = styled.button`
  display: none;
  @media (max-width: 768px) {
    display: inline-flex;
  }
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: calc(100% - 24px);
  margin: 0 12px 8px 12px;
  height: 40px;
  min-height: 40px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #1a1a291a;
  background: #ffffff;
  color: #1a1a29;
`;

export const MainBlock = styled.div<{ $open?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 20px;

  padding-inline: 24px;
  height: 64px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    padding-inline: 12px;
    height: auto;
    display: ${(p) => (p.$open ? 'flex' : 'none')};

    /* Make inner controls occupy full width on small screens */
    & > * {
      width: 100% !important;
    }
  }
`;
